export default { // 该需求运行在商家版app > 登录 > 用户协议&隐私政策
  tabs: [
    {
      name: 'PrivacyPolicy',
      path: '/privacyPolicy',
      component: () => import('./src/privacyPolicy.vue'),
      meta: {
        title: '隐私政策',
        isMenu: true
      }
    },
    {
      name: 'UserAgreement',
      path: '/userAgreement',
      component: () => import('./src/userAgreement.vue'),
      meta: {
        title: '用户协议',
        isMenu: true
      }
    },
    {
      name: 'PermissionDetails',
      path: '/permissionDetails',
      component: () => import('./src/permissionDetails.vue'),
      meta: {
        title: 'APP 权限明细表',
        isMenu: true
      }
    },
    {
      name: 'SharedInformation',
      path: '/sharedInformation',
      component: () => import('./src/sharedInformation.vue'),
      meta: {
        title: '共享个人信息清单',
        isMenu: true
      }
    }
  ]
}
